module.exports = __webpack_public_path__ + "static/3_3_spam-or-ham_CS-cf9b8b5c5f0a48fc1c9718613014ce62.svg";